<template>
  <select :name="name" @change="handleChange" v-model="localValue">
    <option
      v-for="(option, key) in options"
      :disabled="option.disabled"
      :value="option.value"
      :key="key"
      >{{ option.text }}</option
    >
    <slot></slot>
  </select>
</template>

<script>
import { fieldMixin, formErrorMixin } from "../../../mixins";

export default {
  mixins: [fieldMixin, formErrorMixin],

  props: {
    value: {},
    options: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      localValue: this.value
    };
  },

  created() {
    this.registerField();
  },

  watch: {
    value(newVal, oldVal) {
      this.localValue = newVal;
    },

    localValue(newVal, oldVal) {
      this.$emit("input", this.localValue);
    }
  },

  methods: {
    handleChange(event) {
      this.localValue = event.target.value;
      this.$emit("change", this.localValue);
    }
  }
};
</script>
